// -------------------------------------------------------------------------------

// PLEASE DO NOT EDIT THIS FILE, IT IS GENERATED AND WILL BE OVERWRITTEN:
// https://github.com/ccxt/ccxt/blob/master/CONTRIBUTING.md#how-to-contribute-code

// -------------------------------------------------------------------------------

import { Dict } from '../base/types.js';
import { Exchange as _Exchange } from '../base/Exchange.js';

interface Exchange {
    publicGetCurrencies (params?: {}): Promise<Dict>;
    publicGetCurrenciesCurrency (params?: {}): Promise<Dict>;
    publicGetSymbols (params?: {}): Promise<Dict>;
    publicGetMarketOrderbookLevel1 (params?: {}): Promise<Dict>;
    publicGetMarketAllTickers (params?: {}): Promise<Dict>;
    publicGetMarketStats (params?: {}): Promise<Dict>;
    publicGetMarkets (params?: {}): Promise<Dict>;
    publicGetMarketOrderbookLevelLevelLimit (params?: {}): Promise<Dict>;
    publicGetMarketOrderbookLevel220 (params?: {}): Promise<Dict>;
    publicGetMarketOrderbookLevel2100 (params?: {}): Promise<Dict>;
    publicGetMarketHistories (params?: {}): Promise<Dict>;
    publicGetMarketCandles (params?: {}): Promise<Dict>;
    publicGetPrices (params?: {}): Promise<Dict>;
    publicGetTimestamp (params?: {}): Promise<Dict>;
    publicGetStatus (params?: {}): Promise<Dict>;
    publicGetMarkPriceSymbolCurrent (params?: {}): Promise<Dict>;
    publicGetMarkPriceAllSymbols (params?: {}): Promise<Dict>;
    publicGetMarginConfig (params?: {}): Promise<Dict>;
    publicGetAnnouncements (params?: {}): Promise<Dict>;
    publicGetMarginCollateralRatio (params?: {}): Promise<Dict>;
    publicGetConvertSymbol (params?: {}): Promise<Dict>;
    publicGetConvertCurrencies (params?: {}): Promise<Dict>;
    publicPostBulletPublic (params?: {}): Promise<Dict>;
    privateGetUserInfo (params?: {}): Promise<Dict>;
    privateGetUserApiKey (params?: {}): Promise<Dict>;
    privateGetAccounts (params?: {}): Promise<Dict>;
    privateGetAccountsAccountId (params?: {}): Promise<Dict>;
    privateGetAccountsLedgers (params?: {}): Promise<Dict>;
    privateGetHfAccountsLedgers (params?: {}): Promise<Dict>;
    privateGetHfMarginAccountLedgers (params?: {}): Promise<Dict>;
    privateGetTransactionHistory (params?: {}): Promise<Dict>;
    privateGetSubUser (params?: {}): Promise<Dict>;
    privateGetSubAccountsSubUserId (params?: {}): Promise<Dict>;
    privateGetSubAccounts (params?: {}): Promise<Dict>;
    privateGetSubApiKey (params?: {}): Promise<Dict>;
    privateGetMarginAccount (params?: {}): Promise<Dict>;
    privateGetMarginAccounts (params?: {}): Promise<Dict>;
    privateGetIsolatedAccounts (params?: {}): Promise<Dict>;
    privateGetDepositAddresses (params?: {}): Promise<Dict>;
    privateGetDeposits (params?: {}): Promise<Dict>;
    privateGetHistDeposits (params?: {}): Promise<Dict>;
    privateGetWithdrawals (params?: {}): Promise<Dict>;
    privateGetHistWithdrawals (params?: {}): Promise<Dict>;
    privateGetWithdrawalsQuotas (params?: {}): Promise<Dict>;
    privateGetAccountsTransferable (params?: {}): Promise<Dict>;
    privateGetTransferList (params?: {}): Promise<Dict>;
    privateGetBaseFee (params?: {}): Promise<Dict>;
    privateGetTradeFees (params?: {}): Promise<Dict>;
    privateGetMarketOrderbookLevelLevel (params?: {}): Promise<Dict>;
    privateGetMarketOrderbookLevel2 (params?: {}): Promise<Dict>;
    privateGetMarketOrderbookLevel3 (params?: {}): Promise<Dict>;
    privateGetHfAccountsOpened (params?: {}): Promise<Dict>;
    privateGetHfOrdersActive (params?: {}): Promise<Dict>;
    privateGetHfOrdersActiveSymbols (params?: {}): Promise<Dict>;
    privateGetHfMarginOrderActiveSymbols (params?: {}): Promise<Dict>;
    privateGetHfOrdersDone (params?: {}): Promise<Dict>;
    privateGetHfOrdersOrderId (params?: {}): Promise<Dict>;
    privateGetHfOrdersClientOrderClientOid (params?: {}): Promise<Dict>;
    privateGetHfOrdersDeadCancelAllQuery (params?: {}): Promise<Dict>;
    privateGetHfFills (params?: {}): Promise<Dict>;
    privateGetOrders (params?: {}): Promise<Dict>;
    privateGetLimitOrders (params?: {}): Promise<Dict>;
    privateGetOrdersOrderId (params?: {}): Promise<Dict>;
    privateGetOrderClientOrderClientOid (params?: {}): Promise<Dict>;
    privateGetFills (params?: {}): Promise<Dict>;
    privateGetLimitFills (params?: {}): Promise<Dict>;
    privateGetStopOrder (params?: {}): Promise<Dict>;
    privateGetStopOrderOrderId (params?: {}): Promise<Dict>;
    privateGetStopOrderQueryOrderByClientOid (params?: {}): Promise<Dict>;
    privateGetOcoOrderOrderId (params?: {}): Promise<Dict>;
    privateGetOcoOrderDetailsOrderId (params?: {}): Promise<Dict>;
    privateGetOcoClientOrderClientOid (params?: {}): Promise<Dict>;
    privateGetOcoOrders (params?: {}): Promise<Dict>;
    privateGetHfMarginOrdersActive (params?: {}): Promise<Dict>;
    privateGetHfMarginOrdersDone (params?: {}): Promise<Dict>;
    privateGetHfMarginOrdersOrderId (params?: {}): Promise<Dict>;
    privateGetHfMarginOrdersClientOrderClientOid (params?: {}): Promise<Dict>;
    privateGetHfMarginFills (params?: {}): Promise<Dict>;
    privateGetHfMarginStopOrders (params?: {}): Promise<Dict>;
    privateGetHfMarginStopOrderOrderId (params?: {}): Promise<Dict>;
    privateGetHfMarginStopOrderClientOid (params?: {}): Promise<Dict>;
    privateGetHfMarginOcoOrderOrderId (params?: {}): Promise<Dict>;
    privateGetHfMarginOcoOrderClientOid (params?: {}): Promise<Dict>;
    privateGetHfMarginOcoOrderDetailOrderId (params?: {}): Promise<Dict>;
    privateGetHfMarginOcoOrders (params?: {}): Promise<Dict>;
    privateGetEtfInfo (params?: {}): Promise<Dict>;
    privateGetMarginCurrencies (params?: {}): Promise<Dict>;
    privateGetRiskLimitStrategy (params?: {}): Promise<Dict>;
    privateGetIsolatedSymbols (params?: {}): Promise<Dict>;
    privateGetMarginSymbols (params?: {}): Promise<Dict>;
    privateGetIsolatedAccountSymbol (params?: {}): Promise<Dict>;
    privateGetMarginBorrow (params?: {}): Promise<Dict>;
    privateGetMarginRepay (params?: {}): Promise<Dict>;
    privateGetMarginInterest (params?: {}): Promise<Dict>;
    privateGetProjectList (params?: {}): Promise<Dict>;
    privateGetProjectMarketInterestRate (params?: {}): Promise<Dict>;
    privateGetRedeemOrders (params?: {}): Promise<Dict>;
    privateGetPurchaseOrders (params?: {}): Promise<Dict>;
    privateGetBrokerApiRebaseDownload (params?: {}): Promise<Dict>;
    privateGetBrokerQueryMyCommission (params?: {}): Promise<Dict>;
    privateGetBrokerQueryUser (params?: {}): Promise<Dict>;
    privateGetBrokerQueryDetailByUid (params?: {}): Promise<Dict>;
    privateGetMigrateUserAccountStatus (params?: {}): Promise<Dict>;
    privateGetConvertQuote (params?: {}): Promise<Dict>;
    privateGetConvertOrderDetail (params?: {}): Promise<Dict>;
    privateGetConvertOrderHistory (params?: {}): Promise<Dict>;
    privateGetConvertLimitQuote (params?: {}): Promise<Dict>;
    privateGetConvertLimitOrderDetail (params?: {}): Promise<Dict>;
    privateGetConvertLimitOrders (params?: {}): Promise<Dict>;
    privateGetAffiliateInviterStatistics (params?: {}): Promise<Dict>;
    privatePostSubUserCreated (params?: {}): Promise<Dict>;
    privatePostSubApiKey (params?: {}): Promise<Dict>;
    privatePostSubApiKeyUpdate (params?: {}): Promise<Dict>;
    privatePostDepositAddresses (params?: {}): Promise<Dict>;
    privatePostWithdrawals (params?: {}): Promise<Dict>;
    privatePostAccountsUniversalTransfer (params?: {}): Promise<Dict>;
    privatePostAccountsSubTransfer (params?: {}): Promise<Dict>;
    privatePostAccountsInnerTransfer (params?: {}): Promise<Dict>;
    privatePostTransferOut (params?: {}): Promise<Dict>;
    privatePostTransferIn (params?: {}): Promise<Dict>;
    privatePostHfOrders (params?: {}): Promise<Dict>;
    privatePostHfOrdersTest (params?: {}): Promise<Dict>;
    privatePostHfOrdersSync (params?: {}): Promise<Dict>;
    privatePostHfOrdersMulti (params?: {}): Promise<Dict>;
    privatePostHfOrdersMultiSync (params?: {}): Promise<Dict>;
    privatePostHfOrdersAlter (params?: {}): Promise<Dict>;
    privatePostHfOrdersDeadCancelAll (params?: {}): Promise<Dict>;
    privatePostOrders (params?: {}): Promise<Dict>;
    privatePostOrdersTest (params?: {}): Promise<Dict>;
    privatePostOrdersMulti (params?: {}): Promise<Dict>;
    privatePostStopOrder (params?: {}): Promise<Dict>;
    privatePostOcoOrder (params?: {}): Promise<Dict>;
    privatePostHfMarginOrder (params?: {}): Promise<Dict>;
    privatePostHfMarginOrderTest (params?: {}): Promise<Dict>;
    privatePostHfMarginStopOrder (params?: {}): Promise<Dict>;
    privatePostMarginOrder (params?: {}): Promise<Dict>;
    privatePostMarginOrderTest (params?: {}): Promise<Dict>;
    privatePostHfMarginOcoOrder (params?: {}): Promise<Dict>;
    privatePostMarginBorrow (params?: {}): Promise<Dict>;
    privatePostMarginRepay (params?: {}): Promise<Dict>;
    privatePostPurchase (params?: {}): Promise<Dict>;
    privatePostRedeem (params?: {}): Promise<Dict>;
    privatePostLendPurchaseUpdate (params?: {}): Promise<Dict>;
    privatePostConvertOrder (params?: {}): Promise<Dict>;
    privatePostConvertLimitOrder (params?: {}): Promise<Dict>;
    privatePostBulletPrivate (params?: {}): Promise<Dict>;
    privatePostPositionUpdateUserLeverage (params?: {}): Promise<Dict>;
    privatePostDepositAddressCreate (params?: {}): Promise<Dict>;
    privateDeleteSubApiKey (params?: {}): Promise<Dict>;
    privateDeleteWithdrawalsWithdrawalId (params?: {}): Promise<Dict>;
    privateDeleteHfOrdersOrderId (params?: {}): Promise<Dict>;
    privateDeleteHfOrdersSyncOrderId (params?: {}): Promise<Dict>;
    privateDeleteHfOrdersClientOrderClientOid (params?: {}): Promise<Dict>;
    privateDeleteHfOrdersSyncClientOrderClientOid (params?: {}): Promise<Dict>;
    privateDeleteHfOrdersCancelOrderId (params?: {}): Promise<Dict>;
    privateDeleteHfOrders (params?: {}): Promise<Dict>;
    privateDeleteHfOrdersCancelAll (params?: {}): Promise<Dict>;
    privateDeleteOrdersOrderId (params?: {}): Promise<Dict>;
    privateDeleteOrderClientOrderClientOid (params?: {}): Promise<Dict>;
    privateDeleteOrders (params?: {}): Promise<Dict>;
    privateDeleteStopOrderOrderId (params?: {}): Promise<Dict>;
    privateDeleteStopOrderCancelOrderByClientOid (params?: {}): Promise<Dict>;
    privateDeleteStopOrderCancel (params?: {}): Promise<Dict>;
    privateDeleteOcoOrderOrderId (params?: {}): Promise<Dict>;
    privateDeleteOcoClientOrderClientOid (params?: {}): Promise<Dict>;
    privateDeleteOcoOrders (params?: {}): Promise<Dict>;
    privateDeleteHfMarginOrdersOrderId (params?: {}): Promise<Dict>;
    privateDeleteHfMarginOrdersClientOrderClientOid (params?: {}): Promise<Dict>;
    privateDeleteHfMarginOrders (params?: {}): Promise<Dict>;
    privateDeleteHfMarginStopOrderCancelById (params?: {}): Promise<Dict>;
    privateDeleteHfMarginStopOrderCancelByClientOid (params?: {}): Promise<Dict>;
    privateDeleteHfMarginStopOrderCancel (params?: {}): Promise<Dict>;
    privateDeleteHfMarginOcoOrderCancelById (params?: {}): Promise<Dict>;
    privateDeleteHfMarginOcoOrderCancelByClientOid (params?: {}): Promise<Dict>;
    privateDeleteHfMarginOcoOrderCancel (params?: {}): Promise<Dict>;
    privateDeleteConvertLimitOrderCancel (params?: {}): Promise<Dict>;
    futuresPublicGetContractsActive (params?: {}): Promise<Dict>;
    futuresPublicGetContractsSymbol (params?: {}): Promise<Dict>;
    futuresPublicGetTicker (params?: {}): Promise<Dict>;
    futuresPublicGetAllTickers (params?: {}): Promise<Dict>;
    futuresPublicGetLevel2Snapshot (params?: {}): Promise<Dict>;
    futuresPublicGetLevel2Depth20 (params?: {}): Promise<Dict>;
    futuresPublicGetLevel2Depth100 (params?: {}): Promise<Dict>;
    futuresPublicGetTradeHistory (params?: {}): Promise<Dict>;
    futuresPublicGetKlineQuery (params?: {}): Promise<Dict>;
    futuresPublicGetInterestQuery (params?: {}): Promise<Dict>;
    futuresPublicGetIndexQuery (params?: {}): Promise<Dict>;
    futuresPublicGetMarkPriceSymbolCurrent (params?: {}): Promise<Dict>;
    futuresPublicGetPremiumQuery (params?: {}): Promise<Dict>;
    futuresPublicGetTradeStatistics (params?: {}): Promise<Dict>;
    futuresPublicGetFundingRateSymbolCurrent (params?: {}): Promise<Dict>;
    futuresPublicGetContractFundingRates (params?: {}): Promise<Dict>;
    futuresPublicGetTimestamp (params?: {}): Promise<Dict>;
    futuresPublicGetStatus (params?: {}): Promise<Dict>;
    futuresPublicGetLevel2MessageQuery (params?: {}): Promise<Dict>;
    futuresPublicGetContractsRiskLimitSymbol (params?: {}): Promise<Dict>;
    futuresPublicGetLevel3MessageQuery (params?: {}): Promise<Dict>;
    futuresPublicGetLevel3Snapshot (params?: {}): Promise<Dict>;
    futuresPublicPostBulletPublic (params?: {}): Promise<Dict>;
    futuresPrivateGetTransactionHistory (params?: {}): Promise<Dict>;
    futuresPrivateGetAccountOverview (params?: {}): Promise<Dict>;
    futuresPrivateGetAccountOverviewAll (params?: {}): Promise<Dict>;
    futuresPrivateGetTransferList (params?: {}): Promise<Dict>;
    futuresPrivateGetOrders (params?: {}): Promise<Dict>;
    futuresPrivateGetStopOrders (params?: {}): Promise<Dict>;
    futuresPrivateGetRecentDoneOrders (params?: {}): Promise<Dict>;
    futuresPrivateGetOrdersOrderId (params?: {}): Promise<Dict>;
    futuresPrivateGetOrdersByClientOid (params?: {}): Promise<Dict>;
    futuresPrivateGetFills (params?: {}): Promise<Dict>;
    futuresPrivateGetRecentFills (params?: {}): Promise<Dict>;
    futuresPrivateGetTradeFees (params?: {}): Promise<Dict>;
    futuresPrivateGetOpenOrderStatistics (params?: {}): Promise<Dict>;
    futuresPrivateGetPosition (params?: {}): Promise<Dict>;
    futuresPrivateGetPositions (params?: {}): Promise<Dict>;
    futuresPrivateGetMarginMaxWithdrawMargin (params?: {}): Promise<Dict>;
    futuresPrivateGetContractsRiskLimitSymbol (params?: {}): Promise<Dict>;
    futuresPrivateGetFundingHistory (params?: {}): Promise<Dict>;
    futuresPrivateGetCopyTradeFuturesGetMaxOpenSize (params?: {}): Promise<Dict>;
    futuresPrivateGetCopyTradeFuturesPositionMarginMaxWithdrawMargin (params?: {}): Promise<Dict>;
    futuresPrivateGetHistoryPositions (params?: {}): Promise<Dict>;
    futuresPrivateGetPositionGetMarginMode (params?: {}): Promise<Dict>;
    futuresPrivateGetPositionGetPositionMode (params?: {}): Promise<Dict>;
    futuresPrivateGetDepositAddress (params?: {}): Promise<Dict>;
    futuresPrivateGetDepositList (params?: {}): Promise<Dict>;
    futuresPrivateGetWithdrawalsQuotas (params?: {}): Promise<Dict>;
    futuresPrivateGetWithdrawalList (params?: {}): Promise<Dict>;
    futuresPrivateGetSubApiKey (params?: {}): Promise<Dict>;
    futuresPrivateGetTradeStatistics (params?: {}): Promise<Dict>;
    futuresPrivateGetGetMaxOpenSize (params?: {}): Promise<Dict>;
    futuresPrivateGetGetCrossUserLeverage (params?: {}): Promise<Dict>;
    futuresPrivatePostTransferOut (params?: {}): Promise<Dict>;
    futuresPrivatePostTransferIn (params?: {}): Promise<Dict>;
    futuresPrivatePostOrders (params?: {}): Promise<Dict>;
    futuresPrivatePostStOrders (params?: {}): Promise<Dict>;
    futuresPrivatePostOrdersTest (params?: {}): Promise<Dict>;
    futuresPrivatePostOrdersMulti (params?: {}): Promise<Dict>;
    futuresPrivatePostPositionMarginAutoDepositStatus (params?: {}): Promise<Dict>;
    futuresPrivatePostMarginWithdrawMargin (params?: {}): Promise<Dict>;
    futuresPrivatePostPositionMarginDepositMargin (params?: {}): Promise<Dict>;
    futuresPrivatePostPositionRiskLimitLevelChange (params?: {}): Promise<Dict>;
    futuresPrivatePostCopyTradeFuturesOrders (params?: {}): Promise<Dict>;
    futuresPrivatePostCopyTradeFuturesOrdersTest (params?: {}): Promise<Dict>;
    futuresPrivatePostCopyTradeFuturesStOrders (params?: {}): Promise<Dict>;
    futuresPrivatePostCopyTradeFuturesPositionMarginDepositMargin (params?: {}): Promise<Dict>;
    futuresPrivatePostCopyTradeFuturesPositionMarginWithdrawMargin (params?: {}): Promise<Dict>;
    futuresPrivatePostCopyTradeFuturesPositionRiskLimitLevelChange (params?: {}): Promise<Dict>;
    futuresPrivatePostCopyTradeFuturesPositionMarginAutoDepositStatus (params?: {}): Promise<Dict>;
    futuresPrivatePostCopyTradeFuturesPositionChangeMarginMode (params?: {}): Promise<Dict>;
    futuresPrivatePostCopyTradeFuturesPositionChangeCrossUserLeverage (params?: {}): Promise<Dict>;
    futuresPrivatePostCopyTradeGetCrossModeMarginRequirement (params?: {}): Promise<Dict>;
    futuresPrivatePostCopyTradePositionSwitchPositionMode (params?: {}): Promise<Dict>;
    futuresPrivatePostChangeCrossUserLeverage (params?: {}): Promise<Dict>;
    futuresPrivatePostWithdrawals (params?: {}): Promise<Dict>;
    futuresPrivatePostSubApiKey (params?: {}): Promise<Dict>;
    futuresPrivatePostSubApiKeyUpdate (params?: {}): Promise<Dict>;
    futuresPrivatePostPositionChangeMarginMode (params?: {}): Promise<Dict>;
    futuresPrivatePostPositionSwitchPositionMode (params?: {}): Promise<Dict>;
    futuresPrivatePostBulletPrivate (params?: {}): Promise<Dict>;
    futuresPrivateDeleteOrdersOrderId (params?: {}): Promise<Dict>;
    futuresPrivateDeleteOrdersClientOrderClientOid (params?: {}): Promise<Dict>;
    futuresPrivateDeleteOrders (params?: {}): Promise<Dict>;
    futuresPrivateDeleteStopOrders (params?: {}): Promise<Dict>;
    futuresPrivateDeleteCopyTradeFuturesOrders (params?: {}): Promise<Dict>;
    futuresPrivateDeleteCopyTradeFuturesOrdersClientOrder (params?: {}): Promise<Dict>;
    futuresPrivateDeleteOrdersMultiCancel (params?: {}): Promise<Dict>;
    futuresPrivateDeleteWithdrawalsWithdrawalId (params?: {}): Promise<Dict>;
    futuresPrivateDeleteCancelTransferOut (params?: {}): Promise<Dict>;
    futuresPrivateDeleteSubApiKey (params?: {}): Promise<Dict>;
    webExchangeGetCurrencyCurrencyChainInfo (params?: {}): Promise<Dict>;
    webExchangeGetContractSymbolFundingRates (params?: {}): Promise<Dict>;
    brokerGetBrokerNdInfo (params?: {}): Promise<Dict>;
    brokerGetBrokerNdAccount (params?: {}): Promise<Dict>;
    brokerGetBrokerNdAccountApikey (params?: {}): Promise<Dict>;
    brokerGetBrokerNdRebaseDownload (params?: {}): Promise<Dict>;
    brokerGetAssetNdbrokerDepositList (params?: {}): Promise<Dict>;
    brokerGetBrokerNdTransferDetail (params?: {}): Promise<Dict>;
    brokerGetBrokerNdDepositDetail (params?: {}): Promise<Dict>;
    brokerGetBrokerNdWithdrawDetail (params?: {}): Promise<Dict>;
    brokerPostBrokerNdTransfer (params?: {}): Promise<Dict>;
    brokerPostBrokerNdAccount (params?: {}): Promise<Dict>;
    brokerPostBrokerNdAccountApikey (params?: {}): Promise<Dict>;
    brokerPostBrokerNdAccountUpdateApikey (params?: {}): Promise<Dict>;
    brokerDeleteBrokerNdAccountApikey (params?: {}): Promise<Dict>;
    earnGetOtcLoanDiscountRateConfigs (params?: {}): Promise<Dict>;
    earnGetOtcLoanLoan (params?: {}): Promise<Dict>;
    earnGetOtcLoanAccounts (params?: {}): Promise<Dict>;
    earnGetEarnRedeemPreview (params?: {}): Promise<Dict>;
    earnGetEarnSavingProducts (params?: {}): Promise<Dict>;
    earnGetEarnHoldAssets (params?: {}): Promise<Dict>;
    earnGetEarnPromotionProducts (params?: {}): Promise<Dict>;
    earnGetEarnKcsStakingProducts (params?: {}): Promise<Dict>;
    earnGetEarnStakingProducts (params?: {}): Promise<Dict>;
    earnGetEarnEthStakingProducts (params?: {}): Promise<Dict>;
    earnGetStructEarnDualProducts (params?: {}): Promise<Dict>;
    earnGetStructEarnOrders (params?: {}): Promise<Dict>;
    earnPostEarnOrders (params?: {}): Promise<Dict>;
    earnPostStructEarnOrders (params?: {}): Promise<Dict>;
    earnDeleteEarnOrders (params?: {}): Promise<Dict>;
    utaGetMarketAnnouncement (params?: {}): Promise<Dict>;
    utaGetMarketCurrency (params?: {}): Promise<Dict>;
    utaGetAssetCurrencies (params?: {}): Promise<Dict>;
    utaGetMarketInstrument (params?: {}): Promise<Dict>;
    utaGetMarketTicker (params?: {}): Promise<Dict>;
    utaGetMarketTrade (params?: {}): Promise<Dict>;
    utaGetMarketKline (params?: {}): Promise<Dict>;
    utaGetMarketFundingRate (params?: {}): Promise<Dict>;
    utaGetMarketFundingRateHistory (params?: {}): Promise<Dict>;
    utaGetMarketCrossConfig (params?: {}): Promise<Dict>;
    utaGetMarketCollateralDiscountRatio (params?: {}): Promise<Dict>;
    utaGetMarketIndexPrice (params?: {}): Promise<Dict>;
    utaGetMarketPositionTiers (params?: {}): Promise<Dict>;
    utaGetMarketOpenInterest (params?: {}): Promise<Dict>;
    utaGetServerStatus (params?: {}): Promise<Dict>;
    utaGetMarketBorrowableCurrency (params?: {}): Promise<Dict>;
    utaGetUserMyIp (params?: {}): Promise<Dict>;
    utaGetMarketFiatPrice (params?: {}): Promise<Dict>;
    utaPrivateGetMarketOrderbook (params?: {}): Promise<Dict>;
    utaPrivateGetAccountBalance (params?: {}): Promise<Dict>;
    utaPrivateGetAccountTransferQuota (params?: {}): Promise<Dict>;
    utaPrivateGetAccountMode (params?: {}): Promise<Dict>;
    utaPrivateGetAccountLedger (params?: {}): Promise<Dict>;
    utaPrivateGetAccountInterestHistory (params?: {}): Promise<Dict>;
    utaPrivateGetAssetDepositAddress (params?: {}): Promise<Dict>;
    utaPrivateGetAccountDepositAddress (params?: {}): Promise<Dict>;
    utaPrivateGetAccountModeAccountBalance (params?: {}): Promise<Dict>;
    utaPrivateGetAccountModeAccountOverview (params?: {}): Promise<Dict>;
    utaPrivateGetAccountModeOrderDetail (params?: {}): Promise<Dict>;
    utaPrivateGetAccountModeOrderOpenList (params?: {}): Promise<Dict>;
    utaPrivateGetAccountModeOrderHistory (params?: {}): Promise<Dict>;
    utaPrivateGetAccountModeOrderExecution (params?: {}): Promise<Dict>;
    utaPrivateGetAccountModePositionOpenList (params?: {}): Promise<Dict>;
    utaPrivateGetAccountModePositionHistory (params?: {}): Promise<Dict>;
    utaPrivateGetPositionHistory (params?: {}): Promise<Dict>;
    utaPrivateGetAccountModePositionTiers (params?: {}): Promise<Dict>;
    utaPrivateGetSubAccountBalance (params?: {}): Promise<Dict>;
    utaPrivateGetUserFeeRate (params?: {}): Promise<Dict>;
    utaPrivateGetDcpQuery (params?: {}): Promise<Dict>;
    utaPrivateGetUnifiedAccountLeverage (params?: {}): Promise<Dict>;
    utaPrivateGetPositionFundingHistory (params?: {}): Promise<Dict>;
    utaPrivateGetAccountInterestLimits (params?: {}): Promise<Dict>;
    utaPrivatePostAccountTransfer (params?: {}): Promise<Dict>;
    utaPrivatePostAccountMode (params?: {}): Promise<Dict>;
    utaPrivatePostAccountModeAccountModifyLeverage (params?: {}): Promise<Dict>;
    utaPrivatePostAccountModeOrderPlace (params?: {}): Promise<Dict>;
    utaPrivatePostAccountModeOrderPlaceBatch (params?: {}): Promise<Dict>;
    utaPrivatePostAccountModeOrderCancel (params?: {}): Promise<Dict>;
    utaPrivatePostAccountModeOrderCancelBatch (params?: {}): Promise<Dict>;
    utaPrivatePostAccountModeOrderCancelAll (params?: {}): Promise<Dict>;
    utaPrivatePostSubAccountCanTransferOut (params?: {}): Promise<Dict>;
    utaPrivatePostDcpSet (params?: {}): Promise<Dict>;
    utaPrivatePostAccountModeAccountModifyLeverageMarginCross (params?: {}): Promise<Dict>;
}
abstract class Exchange extends _Exchange {}

export default Exchange
